export default __webpack_public_path__ + "4c2e52c32ca6ac55b7806320878ed272.jpg";